export default "__VITE_ASSET__BSTI9v5l__"